import React, { useState } from "react";
import {
  Label,
  Input,
  Button,
  Form,
  Spinner,
  FormGroup,
  FormFeedback,
} from "reactstrap";
import { Tooltip } from "reactstrap";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getSports } from "store/actions/sportAction";
import { newSchoolsData } from "store/actions/newSchoolsAction";
import { newCollegeUniversities } from "store/actions/newCollegeUniversities";
import { newSchoolsDataByIdAction } from "store/actions/newSchoolsAction";
import { newCollegeUniversityDataById } from "store/actions/newCollegeUniversities";
import { fetchStates } from "store/actions/athleteActions";
import { fetchSchoolStates } from "store/actions/athleteActions";
import { getCollegeCity } from "store/actions/athleteActions";
import { register } from "../../store/actions/authActions";
import { getSchoolCounty } from "store/actions/athleteActions";
import ImageIcon from "../../assets/img/custom/picture-instruction.jpg";
import Logo from "../../assets/img/custom/logo.png";
import RegisterModals from "components/register/RegisterModals";
import RegisterAgreementCheckboxes from "components/register/RegisterAgreementCheckboxes";
import RegisterSchoolSelector from "components/register/RegisterSchoolSelector";
import { Autocomplete, TextField } from "@mui/material";
function Register() {
  let dispatch = useDispatch();
  const [agreementBox, setAgreementBox] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [selectedClause, setSelectedClause] = useState("");
  const [loading, setLoading] = useState(false);
  const [check1, setCheck1] = useState(false);
  const [imgOpen, setImgOpen] = useState(false);
  const [taxOpen, setTaxOpen] = useState(false);
  const [agrOpen, setAgrOpen] = useState(false);
  const [ambassadorAgreement, setAmbassadorAgreement] = useState(false);
  const [athleteAgreement, setAthleteAgreement] = useState(false);
  const [solely, setSolely] = useState(false);
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [datOffBirth, setDatOffBirth] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [paypal, setPaypal] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [chatRate, setChatRate] = useState("");
  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [sport, setSport] = useState("");
  const [sportLevel, setSportLevel] = useState("College athlete");
  const [gender, setGender] = useState("");
  const [state, setState] = useState("");
  const [newSchool, setNewSchool] = useState("");
  const [college, setCollege] = useState("");
  const [tac, setTac] = useState(false);
  const [tol, setTol] = useState(false);
  const [tax, setTax] = useState(false);
  const [nilPolicy, setNilPolicy] = useState(false);
  const [samePolicy, setSamePolicy] = useState(false);
  const [nilEligible, setNilEligible] = useState(false);
  const [schoolAthleteEligible, setschoolAthleteEligible] = useState(false);
  const [photoInstruction, setPhotoInstruction] = useState(false);
  const [stateLaw, setStateLaw] = useState(false);
  const [agreement, setAgreement] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [typicalRestrictions, setTypicalRestrictions] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [customValue, setCustomValue] = useState("");
  const [error, setError] = useState("");
  const [tolOpen, setTolOpen] = useState(false);
  const [tolOpenInfo, setTolOpenInfo] = useState(false);
  const [highSchoolAthleteInfo, sethighSchoolAthleteInfo] = useState(false);
  const [lawModal, setLawModal] = useState(false);
  const [tacModalOpen, setTacModalOpen] = useState(false);
  const [lawData, setLawData] = useState({});
  const [addwhatsappOrZoom, setAddwhatsappOrZoom] = useState(false);
  const [whatsappZoomValue, setWhatsappZoomValue] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [fhpPolicy, setFhpPolicy] = useState(false);
  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [otherCountryCheckbox, setOtherCountryCheckbox] = useState(false);
  const [countryCheckbox, setCountryCheckbox] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [noteToggle, setNoteToggle] = useState({
    imgNote: false,
  });
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [noticeChecked, setNoticeChecked] = useState(false);
  const [noticeAccepted, setNoticeAccepted] = useState(false);
  let auth = useSelector((state) => state.auth);
  const { states, schoolStates, cities, counties } = useSelector(
    (state) => state.athlete
  );
  let { sports } = useSelector((state) => state.sport);
  const { newSchoolsAllData, newSchoolsId } = useSelector(
    (state) => state.schools
  );
  const { newCollegeUniversitiesData, newCollegesDataId } = useSelector(
    (state) => state.collegeAndUniversities
  );

  const toggleLawModal = () => {
    setLawModal(!lawModal);
  };
  const tacModalToggle = () => {
    setTacModalOpen(!tacModalOpen);
  };

  useEffect(() => {
    dispatch(fetchStates());
    dispatch(fetchSchoolStates());
  }, []);

  useEffect(() => {
    if (state != "" && college != "") {
      if (sportLevel == "College athlete") {
        dispatch(newCollegeUniversityDataById(newSchool));
      } else {
        dispatch(newSchoolsDataByIdAction(newSchool));
      }
    }
  }, [newSchool]);

  useEffect(() => {
    if (state != "") {
      if (sportLevel == "College athlete") {
        dispatch(getCollegeCity(state));
      } else {
        dispatch(getSchoolCounty(state));
      }
    }
  }, [state]);

  useEffect(() => {
    if (state != "" && college != "") {
      if (sportLevel == "College athlete") {
        dispatch(newCollegeUniversities(state, college));
      } else {
        dispatch(newSchoolsData(state, college));
      }
    }
  }, [state, college]);

  useEffect(() => {
    dispatch(getSports());
  }, []);

  const agreeToggle = () => {
    setAgrOpen(!agrOpen);
  };
  const imgToggle = () => {
    setImgOpen(!imgOpen);
  };
  const taxToggle = () => {
    setTaxOpen(!taxOpen);
  };
  const tolToggle = () => {
    setTolOpen(!tolOpen);
  };
  const tolInfoToggle = () => {
    setTolOpenInfo(!tolOpenInfo);
  };

  const ambassdorToggle = () => {
    setAmbassadorAgreement(!ambassadorAgreement);
  };
  const highSchoolAthleteInfoToggle = () => {
    sethighSchoolAthleteInfo(!highSchoolAthleteInfo);
  };
  const toggleNote = (name) => {
    let newField = JSON.parse(JSON.stringify(noteToggle));
    for (let field of Object.keys(newField)) {
      if (field != name) newField[field] = false;
    }
    newField[name] = !newField[name];
    setNoteToggle(newField);
  };

  // Fix: add siteAdmin controlled checkbox state
  const [siteAdminAgreement, setSiteAdminAgreement] = useState(false);

  const validateForm = () => {
    const validations = [
      { field: name, message: "First Name is required", id: "firstNameInput" },
      { field: lastName, message: "Last Name is required", id: "lastNameInput" },
      { field: datOffBirth, message: "Date of Birth is required", id: "dobInput" },
      { field: gender, message: "Gender is required", id: "genderMale" },
      { field: email, message: "Email is required", id: "emailInput" },
      { field: password, message: "Password is required", id: "passwordInput" },
      { field: image, message: "Please upload your profile photo", id: "photoUploadBtn" },
      { field: photoInstruction, message: "Please accept photo instructions check", id: "photoInstructionCheck" },
      { field: samePolicy, message: "Please accept the identity policy check", id: "samePolicyCheck" },
      { field: addwhatsappOrZoom, message: "Please select zoom/whatsapp validation choice", id: "contactYes" },
      { field: addwhatsappOrZoom !== "yes" || whatsappZoomValue, message: "Zoom email/WhatsApp number is required", id: "contactMethodValue" },
      { field: paypal, message: "PayPal Email is required", id: "paypalInput" },
      { field: phoneNumber, message: "Phone Number is required", id: "phoneInput" },
      { field: chatRate, message: "Chat rate per minute is required", id: "chatRateInput" },
      { field: selectedValue, message: "Please select your Sport Badge Rate option", id: "badgeRateSelect" },
      { field: selectedValue !== "custom" || customValue, message: "Custom Sport Badge rate is required", id: "customRateInput" },
      { field: sport, message: "Sport selection is required", id: "sport-autocomplete" },
      { field: state, message: "State selection is required", id: "state-autocomplete" },
      { field: state === "OTHER" || college, message: "City/College/County is required", id: "auto-complete-college" },
      { field: state === "OTHER" || newSchool, message: "School selection is required", id: "auto-complete-school" },
      { field: nilPolicy, message: "Please accept NIL policy responsibility", id: "nilPolicyCheck" },
      { field: typicalRestrictions, message: "Please accept typical marks/logos restrictions policy", id: "typicalRestrictionsCheck" },
      { field: stateLaw, message: "Please accept NIL state laws policy", id: "stateLawCheck" },
      { field: tac, message: "Please accept Terms & Conditions", id: "tacCheck" },
      { field: tol, message: "Please accept Terms of License", id: "tolCheck" },
      { field: tax, message: "Please accept Tax responsibility", id: "taxCheck" },
      { field: agreement, message: "Please accept limited registration term agreement", id: "agreementCheck" },
      { field: marketing, message: "Please accept marketing video usage agreement", id: "marketingCheck" },
      { field: siteAdminAgreement, message: "Please accept site administration right of cancellation agreement", id: "siteAdminCheck" },
      { field: athleteAgreement, message: "Please accept hold harmless unauthorized copying agreement", id: "athleteAgreementCheck" },
      { field: solely, message: "Please accept solely responsible NIL tax compliance agreement", id: "solelyCheck" },
      { field: check1, message: "Please accept athletic performance payment disclaimer", id: "check1Check" },
      { field: agreementBox, message: "Please view, read and accept the Brand Ambassador Agreement (Part 31)", id: "ambassadorAgreementLink" },
      { field: nilEligible, message: "Please accept high school/college eligibility rules check", id: "nilEligibleCheck" },
      { field: fhpPolicy, message: "Please accept FHP Policy check", id: "fhpPolicyCheck" }
    ];

    if (sportLevel === "High School athlete") {
      validations.push({ field: schoolAthleteEligible, message: "High school athlete eligibility warning must be checked", id: "hsCheck" });
    }

    for (let val of validations) {
      if (!val.field) {
        toast.error(val.message);
        const element = document.getElementById(val.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.focus();
        }
        return false;
      }
    }
    return true;
  };

  const handleRegistration = () => {
    setSubmitAttempted(true);
    if (!validateForm()) return;

    let creds = {
      name: name,
      lastName: lastName,
      datOffBirth: datOffBirth,
      email: email,
      gender: gender,
      phoneNumber: phoneNumber,
      sport: sport,
      chatRate: Number(chatRate),
      sportBadgeRate: Number(selectedValue === "custom" ? customValue : selectedValue),
      sportLevel: sportLevel,
      state: state,
      college: college,
      new_institute_id:
        sportLevel != "College athlete"
          ? newSchoolsId[0]?.id
          : newCollegesDataId[0]?.id,
      institute_name: newSchool,
      tac: tac,
      nilPolicy: nilPolicy,
      samePolicy: samePolicy,
      fhpPolicy: fhpPolicy,
      stateLaw: stateLaw,
      tol: tol,
      tax: tax,
      photoInstruction: photoInstruction,
      agreement: agreement,
      marketing: marketing,
      typicalRestrictions: typicalRestrictions,
      solely: solely,
      athleteAgreement: athleteAgreement,
      siteAdminAgreement: siteAdminAgreement,
      nilEligible: nilEligible,
      selectedClause: selectedClause,
      img: image,
      paypal_email: paypal,
      whatsappZoomValue: whatsappZoomValue,
      schoolAthlete: schoolAthleteEligible,
      countryCheckbox: countryCheckbox,
      otherCountryCheckbox: otherCountryCheckbox,
    };
    setLoading(true);
    dispatch(
      register(creds, password, () => {
        setLoading(false);
        setCountryCheckbox(false);
        setOtherCountryCheckbox(false);
      })
    );
  };

  const defaultSportProps = {
    options:
      sports.length > 0
        ? [...sports.map((item) => item.sport), "ESports"].sort()
        : [],
    getOptionLabel: (option) => option,
  };
  const statesForMiami = [
    "USA Professional Athlete",
    "Athlete based in Africa",
    "Athlete based in Asia",
    "Athlete based in Australia",
    "Athlete based in Canada",
    "Athlete based in Central America",
    "Athlete based in Europe",
    "Athlete based in South America",
    "Barry University",
    "Florida International University",
    "Miami Dade College",
    "St. Thomas University",
    "University of Miami",
  ];

  const optionStates =
    sportLevel == "College athlete"
      ? states?.map((insti) => {
          return insti;
        })
      : schoolStates?.map((insti) => {
          return insti;
        });

  const getInstitutes = () => {
    let newSchools = [];

    if (
      state === "FLORIDA" &&
      college === "Miami" &&
      sportLevel === "College athlete"
    ) {
      statesForMiami.forEach((insti) => {
        newSchools.push(insti);
      });
    } else if (sportLevel === "College athlete") {
      newCollegeUniversitiesData.forEach((insti) => {
        if (Array.isArray(insti.institutes)) {
          insti.institutes.forEach((ele) => {
            newSchools.push(ele);
          });
        }
      });
    } else {
      newSchoolsAllData.forEach((insti) => {
        if (Array.isArray(insti.institutes)) {
          insti.institutes.forEach((ele) => {
            newSchools.push(ele);
          });
        }
      });
    }

    return newSchools;
  };

  const defaultNewSchoolProps = {
    options: getInstitutes(),
    getOptionLabel: (option) => option,
  };

  const defaultCollegeProps = {
    options:
      sportLevel === "College athlete"
        ? [...(cities?.map((insti) => insti.city) ?? []), "OTHER"]
        : [...(counties?.map((insti) => insti.county) ?? []), "OTHER"],
    getOptionLabel: (option) => option,
  };

  const handleChange = (value) => {
    const input = value.replace(/\D/g, "").substring(0, 10);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    if (input.length > 6) {
      setPhoneNumber(`(${first})-(${middle})-(${last})`);
    } else if (input.length > 3) {
      setPhoneNumber(`(${first})-(${middle})`);
    } else if (input.length >= 0) {
      setPhoneNumber(input);
    }
  };
  const handleNameCheck = (val) => {
    if (/[^a-z A-Z]/.test(val)) {
      return;
    } else {
      setName(val);
    }
  };
  const handleLastNameCheck = (val) => {
    if (/[^a-z A-Z]/.test(val)) {
      return;
    } else {
      setLastName(val);
    }
  };
  const handleDateOfBirthCheck = (val) => {
    const today = new Date();
    const thirteenYearsAgo = new Date(
      today.getFullYear() - 13,
      today.getMonth(),
      today.getDate()
    );
    const selectedDate = new Date(val);

    if (selectedDate > thirteenYearsAgo) {
      toast.warning("You must be at least 13 years old to register.");
    } else {
      setDatOffBirth(val);
    }
  };

  const PolicyToggle = () => {
    setPolicyModalOpen(!policyModalOpen);
  };
  if (auth.registered) {
    return <Redirect to="/auth/email-verification-pending" />;
  }

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    if (e.target.value !== "custom") {
      setCustomValue("");
    }
  };

  const handleCustomInputChange = (e) => {
    const value = e.target.value;
    setCustomValue(value);
    if (
      value === "" ||
      (parseInt(value, 10) >= 20 && parseInt(value, 10) <= 1000)
    ) {
      setError("");
    } else {
      setError("Value must be between $20 and $1000");
    }
  };

  const getSelectedOption = (options, value) =>
    options?.find((opt) => opt?.name === value) ||
    (value ? { name: value } : null);

  const stateOptions = Array.isArray(optionStates)
    ? [...optionStates, { name: "OTHER" }]
    : [{ name: "OTHER" }];

  const allCheckboxesChecked =
    agreementBox &&
    photoInstruction &&
    tax &&
    agreement &&
    tol

  return (
    <>
      <div className="text-center mt-5">
        <Link to="/">
          <img src={Logo} alt="logo" className="logo" />
        </Link>
      </div>

      <div className="d-flex flex-column flex-md-row">
        <div className="flex-grow-1">
          <div className="auth-card">
            <h2 className="auth-heading">Athlete Sign Up</h2>
            <div className="d-flex mt-4 ml-4">
              <Input
                required
                type="checkbox"
                id="ambassadorAgreementLink"
                className={`custom-checkbox ${submitAttempted && !agreementBox ? "is-invalid" : ""}`}
                checked={agreementBox}
                onChange={(e) => {
                  if (e.target.checked) {
                    setAmbassadorAgreement(true);
                  } else {
                    setAgreementBox(false);
                  }
                }}
              />
              <Label className="custom-checkbox-label text-dark mx-4 mt-1" htmlFor="ambassadorAgreementLink">
                <p className="text-dark mb-0">
                  I will read the attached Brand Ambassador Agreement. My agreement thereto will be recorded after Part 31, by my ‘Click to Accept’ near the end of the agreement.{" "}
                  <span
                    className="font-weight-bold pointer"
                    style={{
                      color: agreementBox ? "#007bff" : "#ff4d4d",
                      textDecoration: "underline"
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setAmbassadorAgreement(true);
                    }}
                  >
                    View, Read and then Click.
                  </span>{" "}
                  (REMINDER: YOU MUST CLICK "ACCEPT" ON PART 31 OF THE CONTRACT.)
                </p>
              </Label>
            </div>
            <div className="d-flex mt-4 ml-4">
              <Input
                required
                type="checkbox"
                id="nilEligibleCheck"
                className={`custom-checkbox ${submitAttempted && !nilEligible ? "is-invalid" : ""}`}
                checked={nilEligible}
                onChange={(e) => setNilEligible(e.target.checked)}
              />
              <Label className="custom-checkbox-label text-dark mx-4 mt-1">
                <p className="text-dark">
                  I understand that the Brand Ambassador agreement has a
                  download button after part 31. I further understand that I
                  should rely on the advice from my Advisor regarding providing
                  or not providing details of this agreement to outside parties.
                </p>
              </Label>
            </div>{" "}
            <div className="d-flex mt-4 ml-4">
              <Input
                required
                type="checkbox"
                id="fhpPolicyCheck"
                className={`custom-checkbox ${submitAttempted && !fhpPolicy ? "is-invalid" : ""}`}
                checked={fhpPolicy}
                onChange={(e) => setFhpPolicy(e.target.checked)}
              />
              <Label className="custom-checkbox-label text-dark mx-4 mt-1">
                I agree to price each of my NIL goods or chats at FHP
                as $599 or less per individual Fan buyer.
                {/* <b className="text-primary pointer" onClick={PolicyToggle}>
                  View
                </b> */}
              </Label>
            </div>
            <Label className="mt-3 auth-label">
              Click for College or High School athlete
            </Label>
           <div className="d-flex ml-4 mt-2">
  {/* 1. College athlete option (NO CHANGE) */}
  <div>
    <Input
      type="radio"
      checked={sportLevel == "College athlete"}
      id="d_yes"
      name="sportLevel"
      value="College athlete"
      onChange={(e) => {
        setState("");
        setCollege("");
        setNewSchool("");
        setSportLevel(e.target.value);
      }}
    />
    <Label
      for="d_yes"
      className={`auth-label ${
        sportLevel == "College athlete" ? "text-primary" : ""
      }`}
    >
      NIL-eligible <br /> College athlete
    </Label>
  </div>
  
  {/* 2. High School athlete option (NO CHANGE) */}
  <div className="mx-auto">
    <Input
      type="radio"
      id="d_no"
      name="sportLevel"
      checked={sportLevel == "High School athlete"}
      value="High School athlete"
      onChange={(e) => {
        setState("");
        setCollege("");
        setNewSchool("");
        setSportLevel(e.target.value);
      }}
    />
    <Label
      for="d_no"
      className={`auth-label ${
        sportLevel == "High School athlete" ? "text-primary" : ""
      }`}
    >
      NIL-eligible <br /> High School athlete*
    </Label>
  </div>
  
  {/* 3. Info Button (NEGATIVE MARGIN INCREASED TO PULL IT SIGNIFICANTLY LEFT) */}
  <div className="d-flex align-items-center10 mb-2 mr-" style={{ marginLeft: "-40px" }}> 
    <a
      href="https://firebasestorage.googleapis.com/v0/b/next-sprint-platform.appspot.com/o/attachments%2F388f9987-89bb-4629-97fc-5d3d75c6a81b%2FHS%20NIL%20OPENDORSE%2027%20NOV%202025_d1ankt6.pdf?alt=media&token=f02028c2-d188-4869-9661-f73404de12ec"
      target="_blank"
      rel="noopener noreferrer"
      title="Opendorse PDF"
      style={{
        color: "white", 
        backgroundColor: "blue",
        textDecoration: "none",
        fontWeight: "bold",
        fontSize: "0.8em",
        borderRadius: "50%",
        padding: "0 5px",
        height: "2em", 
        width: "2em",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      i
    </a>
  </div>
</div>
            <Label
              className={`auth-label ${
                sportLevel != "High School athlete" && "d-none"
              }`}
            >
             *If your advisor certifies that your best interest is served by
              you registering here, and you play H.S. sports in one of
            Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, District of Columbia,
            Florida, Georgia, Idaho, Illinois, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts,
           Minnesota, Missouri, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,
           North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina, South Dakota, Tennessee,
            Texas, Utah, Vermont, Virginia, Washington, Wisconsin
              {/* <p className="mt-2">
                <b>NOTE: </b>If you are reliably advised that you are otherwise
                qualified to register here as an Nil-Eligible high school
                Athlete, but you are unable to find your Registration Pathway,
                you can use State: Other, County: Other and High School name:
                Other to register.
              </p> */}
              <br />
              If you have declared yourself self-employed for nil income and/or
              have formed your own company, be sure your advisor agrees you
              qualify for NIL income.
              <br />
              <br />
              NIL income is income earned by student athletes through the use of
              their name, image, and likeness (NIL) in commercial or promotional
              activities. NIL income is taxable and must be reported on federal
              and state tax returns. <br />
              <br />
              NIL income is considered self-employment income, and athletes are
              treated as independent contractors for tax purposes. They will
              need a Form 1099 if their income is more than $600. Athletes can
              report their NIL income and related expenses on Schedule C of
              their tax return.
              <br />
              <br />
              Athletes must typically disclose activities to their athletic
              departments. Activities typically may not include or reference a
              member school, event, game, or championship.
              <br />
              <br />
              *Activities are typically prohibited in vice industries, including
              alcohol, tobacco, gambling, and weapons.
              <br />
              <br />
              *About 6 in 10 (60%) of self-employed people in the United States
              have not incorporated their businesses.
              <br />
              <br />
              <div>
                <div className="d-flex mt-2 ml-3">
                  <Input
                    required
                    type="checkbox"
                    id="hsCheck"
                    className="custom-checkbox"
                    checked={schoolAthleteEligible}
                    onChange={(e) => {
                      setschoolAthleteEligible(e.target.checked);
                      if (e.target.checked == true) {
                        highSchoolAthleteInfoToggle();
                      }
                    }}
                  />
                  <Label className="custom-checkbox-label text-dark mx-3 mt-1">
                    <h2
                      className="text-primary font-weight-bold pointer"
                      onClick={highSchoolAthleteInfoToggle}
                    >
                      Click the link for further information.
                    </h2>
                  </Label>
                </div>
              </div>
            </Label>
           <div
  className={`d-flex mt-2 ml-3 ${
    sportLevel == "High School athlete" && "d-none"
  }`}
>
  <Input
    required
    type="checkbox"
    className="custom-checkbox" // Removed mt-4 ml-3 from Input
    checked={check1}
    onChange={(e) => setCheck1(e.target.checked)}
  />
  <Label className="custom-checkbox-label text-dark mx-3 mt-1">
    <p className="mb-0">
      {/* Use a 'p' tag or 'span' with appropriate text classes */}
      I understand that LEARNING the 6 TRAINING VIDEOS of the Home Page helps
      me succeed at FHP.
    </p>
  </Label>
</div>
          </div>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className={`auth-card `}>
              <Label className="mt-4 auth-label">First Name</Label>
              <Input
                required
                id="firstNameInput"
                placeholder="John"
                type="text"
                className=" custom-input"
                value={name}
                onChange={(e) => handleNameCheck(e.target.value)}
              />
              <Label className="mt-5 auth-label">Last Name</Label>
              <Input
                required
                id="lastNameInput"
                placeholder="mith"
                type="text"
                className=" custom-input"
                value={lastName}
                onChange={(e) => handleLastNameCheck(e.target.value)}
              />
              <br />
              <Label className="mt-5 auth-label mb-2">Date of Birth</Label>
              <Input
                type="date"
                name="date"
                id="dobInput"
                value={datOffBirth}
                className=" custom-input mb-2 pointer"
                onChange={(e) => handleDateOfBirthCheck(e.target.value)}
              />
              <br />
              <Label className="mt-5 auth-label">Gender</Label>
              <div className="d-flex mt-3 ml-4">
                <div>
                  <Input
                    type="radio"
                    checked={gender == "Male"}
                    id="genderMale"
                    name="gender"
                    value="Male"
                    required
                    onChange={(e) => setGender(e.target.value)}
                  />
                  <Label
                    for="male"
                    className={`auth-label ${
                      gender == "Male" ? "text-primary" : ""
                    }`}
                  >
                    Male
                  </Label>
                </div>
                <div className="mx-auto">
                  <Input
                    type="radio"
                    id="female"
                    name="gender"
                    checked={gender == "Female"}
                    value="Female"
                    required
                    onChange={(e) => setGender(e.target.value)}
                  />
                  <Label
                    for="female"
                    className={`auth-label ${
                      gender == "Female" ? "text-primary" : ""
                    }`}
                  >
                    Female
                  </Label>
                </div>
              </div>
              <Label className="mt-5 auth-label">Email</Label>
              <Input
                required
                id="emailInput"
                placeholder="name@gmail.com"
                type="email"
                className=" custom-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Label className="mt-5 auth-label">Password</Label>
              <Input
                required
                id="passwordInput"
                placeholder="Your password"
                type="password"
                className=" custom-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="d-flex justify-content-center mt-3">
                <div className="text-center" style={{ maxWidth: "600px" }}>
                  {/* Show preview if image is uploaded, otherwise show icon */}
                  {imagePreview ? (
                    <div className="mb-3">
                      <img 
                        src={imagePreview} 
                        alt="Uploaded preview" 
                        className="img-fluid" 
                        style={{ 
                          maxWidth: "300px", 
                          maxHeight: "300px",
                          objectFit: "contain",
                          border: "2px solid #ddd",
                          borderRadius: "8px"
                        }} 
                      />
                    </div>
                  ) : (
                    <>
                      <img src={ImageIcon} alt="img-icon" className="img-fluid mb-3" style={{ maxWidth: "300px" }} />
                      <br />
                    </>
                  )}
                  <Button
                    className="custom-btn"
                    id="photoUploadBtn"
                    onClick={() => {
                      toggleNote("imgNote");
                    }}
                    style={{
                      backgroundColor: photoInstruction ? "#007bff" : "#ff4d4d",
                      borderColor: photoInstruction ? "#007bff" : "#ff4d4d",
                      transition:
                        "background-color 0.3s ease, border-color 0.3s ease",
                    }}
                  >
                    <i
                      className={`fa fa-check text-success ${
                        image ? "mt-1 " : "d-none"
                      }`}
                    ></i>{" "}
                    Upload Photo
                  </Button>
                  <br />
                  <p id="photoInstructionCheck" className="text-dark font-weight-bold mt-3 mb-0" style={{ fontSize: "0.9em" }}>
                    (YOU MUST <span style={{ color: "#007bff" }}>CLICK</span> THE BUTTON ABOVE, READ THE INSTRUCTIONS, AND <span style={{ color: "#007bff" }}>CHECK</span> THE REQUIRED CHECKBOX.)
                  </p>
                </div>
              </div>
              <br />
              <div className="d-flex mt-4 ml-4">
                <Input
                  required
                  type="checkbox"
                  id="samePolicyCheck"
                  className="custom-checkbox"
                  checked={samePolicy}
                  onChange={(e) => setSamePolicy(e.target.checked)}
                />
                <Label className="custom-checkbox-label text-dark mx-4 mt-1">
                  <p className="text-dark">
                    I understand that another person might register at FHP with
                    same name as myself, and even submit similar photo. I agree
                    that I am solely responsible to alert FANS to my correct
                    identity on FHP, such as by posting my FHP Registration
                    Number on my Social Media and by posting the ad from
                    ‘Athlete Posts this Ad’ page of FHP.
                  </p>
                </Label>
              </div>
              <br />
              <div className="d-flex flex-column mt-4">
                <Label className="custom-checkbox-label text-dark mx-4 mt-1">
                  <p className="text-dark">
                    Would you allow a sports fan who wants to verify your
                    identity to contact you online?
                  </p>
                </Label>
                <div className="d-block ml-4">
                  <div className="form-check">
                    <Input
                      className="form-check-input"
                      type="radio"
                      id="contactYes"
                      name="contactMethod"
                      checked={addwhatsappOrZoom === "yes"}
                      onChange={() => setAddwhatsappOrZoom("yes")}
                    />
                    <Label
                      className="form-check-label text-dark"
                      htmlFor="contactYes"
                    >
                      Yes
                    </Label>
                  </div>

                  <div className="form-check">
                    <Input
                      className="form-check-input"
                      type="radio"
                      id="contactNo"
                      name="contactMethod"
                      checked={addwhatsappOrZoom === "no"}
                      onChange={() => setAddwhatsappOrZoom("no")}
                    />
                    <Label
                      className="form-check-label text-dark"
                      htmlFor="contactNo"
                    >
                      No
                    </Label>
                  </div>
                </div>
              </div>
              {addwhatsappOrZoom === "yes" && (
                <>
                  <FormGroup className="mt-3">
                    <Label className="auth-label mb-3">
                      Select Contact Method
                    </Label>
                    <Input
                      type="select"
                      id="platformSelect"
                      name="platformSelect"
                      className="form-select"
                      value={selectedPlatform}
                      onChange={(e) => setSelectedPlatform(e.target.value)}
                    >
                      <option value="">-- Select --</option>
                      <option value="whatsapp">WhatsApp</option>
                      <option value="zoom">Zoom</option>
                    </Input>
                  </FormGroup>

                  {selectedPlatform === "whatsapp" && (
                    <>
                      <Label className="auth-label mb-0">
                        Enter WhatsApp Number
                      </Label>
                      <Input
                        required
                        type="tel"
                        id="contactMethodValue"
                        className="custom-input mb-2"
                        placeholder="WhatsApp Number"
                        value={whatsappZoomValue}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^\d*$/.test(input)) {
                            // Only allow digits
                            setWhatsappZoomValue(input);
                          }
                        }}
                        onBlur={() => {
                          if (
                            whatsappZoomValue.length < 7 ||
                            whatsappZoomValue.length > 15
                          ) {
                            toast.error(
                              "Please enter a valid WhatsApp number (7-15 digits)"
                            );
                          }
                        }}
                      />
                    </>
                  )}

                  {selectedPlatform === "zoom" && (
                    <>
                      <Label className="auth-label mb-0">
                        Enter Zoom Email
                      </Label>
                      <Input
                        required
                        type="email"
                        id="contactMethodValue"
                        className="custom-input mb-2"
                        placeholder="Zoom Email"
                        value={whatsappZoomValue}
                        onChange={(e) => setWhatsappZoomValue(e.target.value)}
                        onBlur={() => {
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (!emailRegex.test(whatsappZoomValue)) {
                            toast.error(
                              "Please enter a valid email address for Zoom"
                            );
                          }
                        }}
                      />
                    </>
                  )}
                </>
              )}

              <Label className="mt-5 auth-label mb-0">Paypal Email</Label>
              <Input
                required
                id="paypalInput"
                placeholder="Your PayPal Account Email"
                type="email"
                className=" custom-input mb-2"
                value={paypal}
                onChange={(e) => setPaypal(e.target.value)}
              />
              <Label className="custom-label">
                If you don’t have a PayPal account to receive money, you can
                sign up{" "}
                <a
                  href="https://www.paypal.com/in/webapps/mpp/account-selection"
                  target="_blank"
                >
                  <b>here</b>
                </a>
              </Label>
              <br />
              <Label className="mt-4 auth-label">Phone Number</Label>
              <Input
                required
                type="tel"
                id="phoneInput"
                className=" custom-input"
                value={phoneNumber}
                onChange={(e) => handleChange(e.target.value)}
                placeholder="(xxx)-(xxx)-(xxxx)"
              />
              <br />

              <div className="d-flex justify-content-between align-items-end">
                <div>
                  <Label className="mt-5 auth-label mb-0">Chat Rate</Label>
                </div>
                <div className="pointer" id="chatRateInfo">
                  <i
                    className="fas fa-info-circle fa-lg"
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>

                <Tooltip
                  placement="left"
                  isOpen={tooltipOpen}
                  target="chatRateInfo"
                  toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                  This shows the athlete's current Chat Attendance Fee that
                  users will be charged to Sign Up.
                </Tooltip>
              </div>

              <Input
                required
                id="chatRateInput"
                placeholder="Your Chat Rate Per Chat Attendance"
                type="number"
                className=" custom-input mb-2"
                value={chatRate}
                onChange={(e) => setChatRate(e.target.value)}
                min="0"
              />
              <p className="text-primary mt-2 mb-0">
                <strong>Note:</strong> You can change this value from your profile later.
              </p>
              <div className="d-flex justify-content-between align-items-end">
                <div>
                  <Label className="mt-5 auth-label mb-0">
                    Choose amount Fans pay for your Sport Badge
                  </Label>
                </div>
              </div>
              <Input
                type="select"
                name="select"
                id="badgeRateSelect"
                value={selectedValue}
                onChange={handleSelectChange}
              >
                <option value="">Select Amount</option>
                <option value="4">$4</option>
                <option value="8">$8</option>
                <option value="12">$12</option>
                <option value="custom">Custom</option>
              </Input>
              <p className="text-primary mt-2">
                <strong>Note:</strong> After this initial setting, you can adjust this rate from your profile later.
              </p>
              {selectedValue === "custom" && (
                <FormGroup>
                  <Label for="customRateInput">Enter Custom Rate</Label>
                  <Input
                    type="number"
                    name="customRate"
                    id="customRateInput"
                    placeholder="Enter custom rate"
                    value={customValue}
                    onChange={handleCustomInputChange}
                    min="20"
                    max="1000"
                    invalid={!!error}
                  />
                  {error && <FormFeedback>{error}</FormFeedback>}
                </FormGroup>
              )}
              <Label className="mt-5 auth-label">Sport(s)</Label>
              <Autocomplete
                {...defaultSportProps}
                id="sport-autocomplete"
                autoComplete
                includeInputInList
                onChange={(e, val) => setSport(val)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Sport"
                    variant="standard"
                  />
                )}
              />
              <Label className="text-dark">
                If your sport not listed, email FansHelpPlayers@gmail.com
              </Label>
              <br />

              <RegisterSchoolSelector
                sportLevel={sportLevel}
                state={state}
                setState={setState}
                college={college}
                setCollege={setCollege}
                newSchool={newSchool}
                setNewSchool={setNewSchool}
                stateOptions={stateOptions}
                defaultCollegeProps={defaultCollegeProps}
                defaultNewSchoolProps={defaultNewSchoolProps}
                getSelectedOption={getSelectedOption}
                setLawData={setLawData}
                toggleLawModal={toggleLawModal}
              />
              <br />
              <div
                className={`${sportLevel != "College athlete" && "d-none"}`}
              ></div>
              <div className={`${sportLevel == "College athlete" && "d-none"}`}>
                <Label className="text-dark auth-label">
                  Select your County (HS athlete)
                </Label>
              </div>
              <RegisterAgreementCheckboxes
                nilPolicy={nilPolicy}
                setNilPolicy={setNilPolicy}
                typicalRestrictions={typicalRestrictions}
                setTypicalRestrictions={setTypicalRestrictions}
                stateLaw={stateLaw}
                setStateLaw={setStateLaw}
                tac={tac}
                setTac={setTac}
                tacModalToggle={tacModalToggle}
                tol={tol}
                setTol={setTol}
                tolToggle={tolToggle}
                tax={tax}
                setTax={setTax}
                taxToggle={taxToggle}
                agreement={agreement}
                setAgreement={setAgreement}
                agreeToggle={agreeToggle}
                marketing={marketing}
                setMarketing={setMarketing}
                athleteAgreement={athleteAgreement}
                setAthleteAgreement={setAthleteAgreement}
                solely={solely}
                setSolely={setSolely}
                siteAdminAgreement={siteAdminAgreement}
                setSiteAdminAgreement={setSiteAdminAgreement}
                check1={check1}
                setCheck1={setCheck1}
              />
              <div className="ml-2 ml-md-5 ">
                <div className="text-center">
                  <Button
                    disabled={loading}
                    className="mt-3 auth-button"
                    onClick={handleRegistration}
                  >
                    {loading ? <Spinner size="sm" /> : "Sign Up"}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div className="mt-3 mx-0 mx-md-5 text-center">
        <Label className="auth-label">Already have an account?</Label>{" "}
        <Link to="/auth/login">
          <Label
            className="text-primary auth-label"
            style={{ cursor: "pointer" }}
          >
            {" "}
            <b>
              <u>Login</u>
            </b>
          </Label>
        </Link>
      </div>
      <RegisterModals
        noticeOpen={noticeOpen}
        setNoticeOpen={setNoticeOpen}
        noticeChecked={noticeChecked}
        setNoticeChecked={setNoticeChecked}
        setNoticeAccepted={setNoticeAccepted}
        imgOpen={imgOpen}
        imgToggle={imgToggle}
        setImage={setImage}
        imagePreview={imagePreview}
        setImagePreview={setImagePreview}
        noteToggle={noteToggle}
        toggleNote={toggleNote}
        photoInstruction={photoInstruction}
        setPhotoInstruction={setPhotoInstruction}
        taxOpen={taxOpen}
        taxToggle={taxToggle}
        setTax={setTax}
        policyModalOpen={policyModalOpen}
        PolicyToggle={PolicyToggle}
        agrOpen={agrOpen}
        agreeToggle={agreeToggle}
        setAgreement={setAgreement}
        tolOpen={tolOpen}
        tolToggle={tolToggle}
        setTol={setTol}
        tolOpenInfo={tolOpenInfo}
        tolInfoToggle={tolInfoToggle}
        ambassadorAgreement={ambassadorAgreement}
        ambassdorToggle={ambassdorToggle}
        agreementBox={agreementBox}
        setAgreementBox={setAgreementBox}
        selectedClause={selectedClause}
        setSelectedClause={setSelectedClause}
        setTac={setTac}
        highSchoolAthleteInfo={highSchoolAthleteInfo}
        highSchoolAthleteInfoToggle={highSchoolAthleteInfoToggle}
        lawModal={lawModal}
        toggleLawModal={toggleLawModal}
        lawData={lawData}
        tacModalOpen={tacModalOpen}
        tacModalToggle={tacModalToggle}
      />
    </>
  );
}

export default Register;